<template>
  <!-- 分享账号 -->
  <el-dialog
    :title="$t('button.sharing')"
    :visible.sync="shareVisible"
    width="450px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="from-body">
      <div class="li">
        <label for="">{{ $t("pages.system.text101") }}</label>
        <a :href="shareInfo.domain" target="_blank"
          >https://{{ shareInfo.domain }}</a
        >
      </div>
      <div class="li">
        <label for="">{{ $t("pages.system.text66") }}</label>
        <span>{{ shareInfo.username }}</span>
      </div>
      <div class="li">
        <label for="">{{ $t("pages.system.text102") }}</label>
        <span>{{ shareInfo.password }}</span>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t("button.cancel") }}</el-button>
      <el-button type="primary" @click="copy">{{
        $t("omission.text2")
      }}</el-button>
    </span>
  </el-dialog>
</template>


<script>
export default {
  data() {
    return {};
  },
  props: ["shareVisible", "shareInfo"],
  methods: {
    //取消
    handleClose() {
      this.$emit("shareClose");
    },
    //复制
    copy() {
      let cpContent = [
        this.$t("pages.system.text103") +
          ":" +
          " https://" +
          this.shareInfo.domain +
          "\n",
        this.$t("pages.system.text104") + ":" + this.shareInfo.username + "\n",
        this.$t("pages.system.text102") + ":" + this.shareInfo.password + "\n",
      ].join("");
      let aux = document.createElement("textarea");
      aux.value = cpContent;
      // aux.setAttribute("value", cpContent);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
      /*  this.$message({
        message: "已成功复制到剪切板",
        type: "success",
      }); */
      this.$emit("shareClose");
    },
  },
};
</script>

<style scoped>
.from-body {
  padding: 0 40px;
  box-sizing: border-box;
}
.from-body .li label {
  margin-right: 20px;
}
.from-body .li {
  margin-bottom: 20px;
}
</style>